import { useEffect, useState } from "react";
import { retrunAssets } from "../../utils/getAssets"
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../utils/decodeHtml";
import { MyTable } from "../campusLife/swimmingPoolHours";

const Gem = ({ internationalOffice }) => {
    const img = retrunAssets(internationalOffice?.seeMoreImage[0]?.url) 
    const whatWeDo = DecodeHtml({ html: internationalOffice?.descriptionGEM?.markup })
    const [tableData, setTableData] = useState({
        headers: [],
        mobile: [],
        contents: []
    });

    useEffect(() => {
        const headers = [];
        const mobile = [];
        const contents = [];

        internationalOffice?.table?.items.forEach((item) => {
            // Extract the label for the header
            const headerLabel = item?.content?.properties?.label;
            headers.push(headerLabel);
            mobile.push(headerLabel);

            const rowData = [];
            item?.content?.properties?.content?.items?.forEach((contentItem) => {
                // Extract the content for each cell
                const cellContent = contentItem?.content?.properties?.richText?.markup;
                rowData.push(DecodeHtml({ html: cellContent }));
            });
            contents.push(rowData);
        });

        setTableData({ headers, mobile, contents });
    }, [internationalOffice?.table]);
    return (
        <div className="flex flex-col gap-5 w-full  p-4 max-h-[80vh] max-w-[80vw]  overflow-y-auto scroll-bar">
            <img src={img} className="maz-w-full bg-gray-100 h-auto object-cover rounded-lg italic" alt="Photo" />
            <div className="w-full my-5 whitespace-pre-line">
                {whatWeDo}
            </div>

            <MyTable headers={tableData.headers} mobile={tableData.mobile} contents={tableData.contents} />


        </div>
    )
}
Gem.propTypes = {
    internationalOffice: PropTypes.object
}
export default Gem